import { render, staticRenderFns } from "./dialogCV.vue?vue&type=template&id=508f65d7"
import script from "./dialogCV.vue?vue&type=script&lang=js"
export * from "./dialogCV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports